import React, { FC } from 'react';
import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';
import useOptimizely from 'shared/hooks/optimizely/useOptimizely';
import useLiveRamp from 'shared/hooks/optimizely/useLiveRamp';
import Head from 'next/head';
import { ScriptInline } from '../ScriptInline';

import defaultHeader from './assets/header.html.txt';
import experimentHeaderControl from './assets/header-CRME-1149-control.html.txt';
import experimentHeaderLeftMenu from './assets/header-CRME-1149-left_menu.html.txt';
import experimentHeaderLeftMenuCta from './assets/header-CRME-1149-left_menu_with_cta.html.txt';
import experimentHeaderLeftMenuLabelCta from './assets/header-CRME-1149-left_menu_with_label_and_cta.html.txt';
import liveRampScript from './assets/liveramp-consent-management-platform.min.js.txt';
import { useRouter } from 'next/router';

const variationMap: Record<string, string> = {
    control: experimentHeaderControl,
    left_menu: experimentHeaderLeftMenu,
    left_menu_with_cta: experimentHeaderLeftMenuCta,
    left_menu_with_label_and_cta: experimentHeaderLeftMenuLabelCta
};

const Header: FC<WithOptimizelyProps> = ({ optimizely }) => {
    const _useLiveRamp = useLiveRamp(optimizely);

    const optimizelyVariation = optimizely?.activate(
        'crme_1149_menu_icon_on_left_of_header'
    );
    const optimizelyGoogleOneTapVariation = useOptimizely(
        optimizely,
        'google_one_tap'
    );

    // Stop showing Google One Tap prompt on sign in and register pages
    const router = useRouter();
    const disallowList = new Set(['/signin', '/register']);
    const isInAllowList = !disallowList.has(router.pathname);

    let header = defaultHeader;

    if (optimizelyVariation && variationMap[optimizelyVariation]) {
        header = variationMap[optimizelyVariation];
    }

    return (
        <>
            {_useLiveRamp && (
                <Head>
                    <ScriptInline
                        script={liveRampScript.replace(
                            '{{{segmentID}}}',
                            process.env.SEGMENT_ID!
                        )}
                    />
                </Head>
            )}
            {optimizelyGoogleOneTapVariation && isInAllowList && (
                <Head>
                    <script
                        async
                        src="https://accounts.google.com/gsi/client"
                    />
                </Head>
            )}
            <div
                data-testid="universal-header"
                dangerouslySetInnerHTML={{
                    __html: header
                }}
            />
        </>
    );
};

export default withOptimizely(Header);
